import { render } from "./VideosCarousel.vue?vue&type=template&id=49c5b3ce"
import script from "./VideosCarousel.vue?vue&type=script&lang=js"
export * from "./VideosCarousel.vue?vue&type=script&lang=js"

import "./VideosCarousel.vue?vue&type=style&index=0&id=49c5b3ce&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__